'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$131(ps$81) {
  this.a6O = null;
  this.a6O = ps$81;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$131 as $c_Lmealorama_jsonCodecs$package$$anon$131 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$131.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$131;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$131() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$131 as $h_Lmealorama_jsonCodecs$package$$anon$131 };
$h_Lmealorama_jsonCodecs$package$$anon$131.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6O.a.length;
});
$p.g = (function(i) {
  return this.a6O.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$131 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$131, "mealorama.jsonCodecs$package$$anon$131", ({
  IH: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$131 as $d_Lmealorama_jsonCodecs$package$$anon$131 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$131.js.map
